"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCK_TYPE_TO_INPUT_OUTPUT_TYPE = exports.getBlockTypeToInputOutputDocument = exports.TEXT_AI_BLOCK_TYPES = void 0;
const document_1 = require("../document/document");
const processor_1 = require("./processor");
const input_1 = require("./input");
const block_1 = require("../block");
exports.TEXT_AI_BLOCK_TYPES = [
    processor_1.BlockType_Processor.text_to_text_ai,
    processor_1.BlockType_Processor.text_to_json_ai,
    processor_1.BlockType_Processor.texts_to_text_ai,
    processor_1.BlockType_Processor.search_google_with_ai,
];
function getBlockTypeToInputOutputDocument(block) {
    if (block.blockType == block_1.BlockType.input) {
        return exports.BLOCK_TYPE_TO_INPUT_OUTPUT_TYPE[block.configuration.blockType_Input];
    }
    if (block.blockType == block_1.BlockType.processor) {
        return exports.BLOCK_TYPE_TO_INPUT_OUTPUT_TYPE[block.configuration.blockType_Processor];
    }
    throw new Error("Block is not input or processor");
}
exports.getBlockTypeToInputOutputDocument = getBlockTypeToInputOutputDocument;
exports.BLOCK_TYPE_TO_INPUT_OUTPUT_TYPE = {
    // Input Blocks:
    [input_1.BlockType_Input.file_uploader_pdf]: {
        outputType: document_1.BlockDocumentType.pdf_file
    },
    [input_1.BlockType_Input.file_uploader_text]: {
        outputType: document_1.BlockDocumentType.text_file
    },
    [input_1.BlockType_Input.file_uploader_audio]: {
        outputType: document_1.BlockDocumentType.audio_file
    },
    [input_1.BlockType_Input.file_uploader_video]: {
        outputType: document_1.BlockDocumentType.video_file
    },
    [input_1.BlockType_Input.file_uploader_image]: {
        outputType: document_1.BlockDocumentType.image_file
    },
    [input_1.BlockType_Input.file_uploader_xlsx]: {
        outputType: document_1.BlockDocumentType.xlsx_file
    },
    [input_1.BlockType_Input.text]: {
        outputType: document_1.BlockDocumentType.text_document
    },
    [input_1.BlockType_Input.scheduler]: {
        outputType: document_1.BlockDocumentType.triggered
    },
    // Processor Blocks:
    [processor_1.BlockType_Processor.text_slicer]: {
        inputType: document_1.BlockDocumentType.text_document,
        outputType: document_1.BlockDocumentType.text_document
    },
    [processor_1.BlockType_Processor.text_chunker]: {
        inputType: document_1.BlockDocumentType.text_document,
        outputType: document_1.BlockDocumentType.text_documents
    },
    [processor_1.BlockType_Processor.text_to_text_ai]: {
        inputType: document_1.BlockDocumentType.text_document,
        outputType: document_1.BlockDocumentType.text_document
    },
    [processor_1.BlockType_Processor.text_to_json_ai]: {
        inputType: document_1.BlockDocumentType.text_document,
        outputType: document_1.BlockDocumentType.json_document
    },
    [processor_1.BlockType_Processor.texts_to_text_ai]: {
        inputType: document_1.BlockDocumentType.text_documents,
        outputType: document_1.BlockDocumentType.text_document
    },
    [processor_1.BlockType_Processor.search_google_with_ai]: {
        inputType: document_1.BlockDocumentType.text_document,
        outputType: document_1.BlockDocumentType.text_document
    },
    [processor_1.BlockType_Processor.text_file_loader]: {
        inputType: document_1.BlockDocumentType.text_file,
        outputType: document_1.BlockDocumentType.text_document
    },
    [processor_1.BlockType_Processor.file_pdf_extractor]: {
        inputType: document_1.BlockDocumentType.pdf_file,
        outputType: document_1.BlockDocumentType.text_document
    },
    [processor_1.BlockType_Processor.google_document_ai]: {
        inputType: document_1.BlockDocumentType.text_file,
        outputType: document_1.BlockDocumentType.json_document
    },
    [processor_1.BlockType_Processor.api_google_news]: {
        inputType: document_1.BlockDocumentType.text_document,
        outputType: document_1.BlockDocumentType.text_document
    },
    [processor_1.BlockType_Processor.audio_chunker]: {
        inputType: document_1.BlockDocumentType.audio_file,
        outputType: document_1.BlockDocumentType.audio_file
    },
    [processor_1.BlockType_Processor.audio_compressor]: {
        inputType: document_1.BlockDocumentType.audio_file,
        outputType: document_1.BlockDocumentType.audio_file
    },
    [processor_1.BlockType_Processor.xlsx_file_loader]: {
        inputType: document_1.BlockDocumentType.xlsx_file,
        outputType: document_1.BlockDocumentType.table_document
    },
    [processor_1.BlockType_Processor.table_summarizer]: {
        inputType: document_1.BlockDocumentType.table_document,
        outputType: document_1.BlockDocumentType.table_document
    },
    [processor_1.BlockType_Processor.audio_to_text_ai]: {
        inputType: document_1.BlockDocumentType.audio_file,
        outputType: document_1.BlockDocumentType.text_document
    },
    [processor_1.BlockType_Processor.text_merger]: {
        inputType: document_1.BlockDocumentType.text_document,
        outputType: document_1.BlockDocumentType.text_document
    },
    [processor_1.BlockType_Processor.texts_merger]: {
        inputType: document_1.BlockDocumentType.text_documents,
        outputType: document_1.BlockDocumentType.text_documents
    },
    [input_1.BlockType_Input.youtube_link]: {
        outputType: document_1.BlockDocumentType.link
    },
    [processor_1.BlockType_Processor.link_youtube_extractor]: {
        inputType: document_1.BlockDocumentType.link,
        outputType: document_1.BlockDocumentType.text_document
    },
    [processor_1.BlockType_Processor.search_wikipedia_with_ai]: {
        inputType: document_1.BlockDocumentType.text_document,
        outputType: document_1.BlockDocumentType.text_document
    },
    [processor_1.BlockType_Processor.text_splitter]: {
        inputType: document_1.BlockDocumentType.text_document,
        outputType: document_1.BlockDocumentType.text_documents
    },
    [processor_1.BlockType_Processor.triggered_text_document]: {
        inputType: document_1.BlockDocumentType.triggered,
        outputType: document_1.BlockDocumentType.text_document
    },
    [processor_1.BlockType_Processor.api_google_news_multi]: {
        inputType: document_1.BlockDocumentType.text_documents,
        outputType: document_1.BlockDocumentType.text_document
    },
    [processor_1.BlockType_Processor.send_email]: {
        inputType: document_1.BlockDocumentType.text_document,
        outputType: document_1.BlockDocumentType.json_document
    },
    [processor_1.BlockType_Processor.triggered_get_business_news]: {
        inputType: document_1.BlockDocumentType.triggered,
        outputType: document_1.BlockDocumentType.text_document
    },
};
